<template>
  <div class="header" v-if="isShow">
    <div class="msk" v-show="maskShow"></div>
    <div class="nav">
      <div>
        <img v-if="!leftShow" class="logo" src="@/assets/images/login/ip_logo.png" alt="logo" @click="toHomePage" />
      </div>

      <!-- <span
        class="goback hand"
        @click="goIndex"
        v-if="curUrl !== '/serviceDetail'"
        :class="{ 'monitoring-subscription': curUrl === '/monitoringSubscription' }"
      >
        返回首页
      </span> -->

      <div class="cjt-fr flex bar-right">
        <UserInfo />
      </div>
    </div>
    <!-- 首页弹窗 -->
    <a-modal v-model="visible" :title="null" :footer="null" width="60%" centered @ok="handleOk" destroyOnClose>
      <div class="pagePosition-index-message">
        <h2>{{ messageData.title }}</h2>
        <div class="content">
          <a v-if="messageData.url" :href="messageData.url" target="_blank">
            <img :src="messageData.files" style="max-width: 100%" />
          </a>
          <img :src="messageData.files" style="max-width: 100%" v-else />
        </div>
        <a-button type="primary" @click="visible = false">确认</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import UserInfo from '@/components/common/UserInfo';
import AlertWindow from '@/components/common/AlertWindow';
import { getNav, getPopUpByPagePosition } from '@/api/myOrder.js';
import moment from 'moment';
import Cookie from 'js-cookie';
export default {
  components: {
    UserInfo,
    AlertWindow,
  },
  watch: {
    '$route.path': {
      handler(newVal) {
        this.curUrl = newVal;

        this.maskShow = false;
      },
    },
  },
  data() {
    return {
      maskShow: false,
      navList: [],
      curUrl: '',
      visible: false,
      messageData: {},
    };
  },
  mounted() {
    this.getNav();
    this.curUrl = this.$route.path;
    this.getMessage();
  },
  computed: {
    // 是否显示
    isShow() {
      return !['/paymentSuccess', '/payment', '/trademarkNameReviewReport'].includes(this.$route.path);
    },
    leftShow() {
      return this.$store.state.login.leftShow && !new URLSearchParams(window.location.search).has('embed');
    },
  },
  methods: {
    async getMessage() {
      let res = await getPopUpByPagePosition();
      let cookieMsgId = Cookie.get('cookieMsgIdCZH');
      let today = moment(new Date()).format('YYYY-MM-DD');
      if (res.data.id && cookieMsgId !== today + res.data.id) {
        let setCookieMsgId = today + res.data.id;
        this.messageData = res.data;
        this.visible = true;
        Cookie.set('cookieMsgIdCZH', setCookieMsgId);
      }
    },
    handleOk(e) {
      this.visible = false;
    },
    goIndex() {
      // window.location.href = location.origin;
    },
    getNav() {
      let that = this;
      getNav().then(
        (res) => {
          if (res.code === 0) {
            that.navList = res.data;
          } else {
            that.$Message.error(res.message);
          }
        },
        (err) => {
          that.$Message.error(err.message);
        }
      );
    },
    navHover(item) {
      if (['产品服务'].includes(item.name)) {
        this.maskShow = true;
      } else {
        this.maskShow = false;
      }
    },
    toHomePage() {
      window.location.href = this.homePageUrl;
    },
  },
};
</script>

<style lang="less" scoped>
.msk {
  position: fixed;
  left: 0;
  right: 0;
  top: 64px;
  bottom: 0;
  height: calc(100vh - 64px);
  background: rgba(#000, 0.4);
  z-index: -1;
}
.goback {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 280px;
  font-size: 14px;
}
.monitoring-subscription {
  margin-left: 20px;
}
.header {
  width: 100%;
  height: 64px;
  border-radius: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: #ffffff;
  backdrop-filter: blur(12px);
  &-change {
    background: #fff;
  }
  &:hover {
    background: #fff;
  }
  .nav {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    height: 64px;
    line-height: 64px;
    position: relative;
    font-size: 16px;
    box-shadow: 0px 1px 7px 0px #00000017;
    .logo {
      margin-left: 57px;
      width: 118px;
    }
    .logoPosition {
      margin: 0;
      position: absolute;
      left: 0;
      top: 0;
      padding-left: 29px;
      padding-right: 45px;
      padding-top: 6px;
      background-color: #f3f8ff;
      // box-shadow: 0px 5px 10px 0px #00000040;
    }
    .menulist {
      margin-left: 50px;
      margin-bottom: 0;
      display: inline-flex;
      vertical-align: middle;
      height: 100%;
      li {
        display: inline-flex;
        height: 100%;
        a {
          font-size: 16px;
          font-family:
            PingFang SC-Regular,
            PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.9);
          line-height: 24px;
          padding: 0 15px;
          display: flex;
          align-items: center;
          &.active {
            color: #3a7fff;
          }
          &:hover {
            color: #3a7fff;
          }
        }
        .menucontent {
          position: absolute;
          top: 64px;
          left: 0;
          display: none;
          background: #ffffff;
          box-shadow: 0 2px 12px 1px rgba(16, 68, 166, 0.07);
          border-radius: 0;
          z-index: 99999;
        }
        &:hover .menucontent {
          display: block;
        }
      }
    }
    .bar-right {
      height: 100%;
      margin-right: 20px;
      .change-language {
        margin-right: 10px;
        .icon-earth {
          color: rgba(rgba(0, 0, 0, 0.9), 0.4);
        }
        &:hover {
          color: #3a7fff;
          .icon-earth {
            color: #3a7fff;
          }
          .ant-dropdown-trigger {
            color: #3a7fff;
          }
        }
        .ant-dropdown-trigger {
          cursor: pointer;
          margin-bottom: 0;
          line-height: 70px;
          color: rgba(rgba(0, 0, 0, 0.9), 0.9);
          font-size: 16px;
        }
      }
    }
  }
  &-kby {
  }
}
/deep/ .ant-dropdown {
  .ant-dropdown-menu {
    width: 125px;
    padding: 0;
    text-align: center;
    font-size: 14px;
    color: rgba(rgba(0, 0, 0, 0.9), 0.6);
    box-shadow: 0 2px 12px 0 rgba(16, 68, 166, 0.07);
    border-radius: 4px;
    li {
      &:hover {
        background: #fff;
        color: #3a7fff;
      }
    }
  }
}

.pagePosition-index-message {
  text-align: right;
  h2 {
    text-align: left;
    margin-bottom: 0;
  }
  .content {
    text-align: center;
    padding-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/HeaderNew.vue